import React, { useEffect } from 'react';

import { bem, DIAL_MIN_ID, DIAL_MAX_ID } from './index';

export const Dials = (props) => {
    const {
        container,
        rangeAsPercent: [min, max], // have somethingthat considers the currentDial
        onMouseDown,
        onTouchStart,
    } = props;
    if (!container) {
        return null;
    }
    const { width } = container.getBoundingClientRect();
    const prevWidthRef = React.useRef(width);
    const actualMin = React.useMemo(() => Math.ceil((min / 100) * width), [min, width]);
    const actualMax = React.useMemo(() => {
        if (prevWidthRef.current > width && max === 100) return prevWidthRef.current;
        return Math.ceil((max / 100) * width);
    }, [max, width]);

    useEffect(() => {
        prevWidthRef.current = width;
    }, [max, width]);

    return [
        <div key={DIAL_MIN_ID} className={bem('dial', 'min')} style={{ left: actualMin }}>
            <div
                role="slider"
                aria-valuemin={0}
                aria-valuemax={actualMax}
                aria-valuenow={actualMin}
                onMouseDown={(e) => onMouseDown(e, { isTouch: false, handleID: DIAL_MIN_ID })}
                onTouchStart={(e) => onTouchStart(e, { isTouch: true, handleID: DIAL_MIN_ID })}
            />
        </div>,
        <div key={DIAL_MAX_ID} className={bem('dial', 'max')} style={{ left: actualMax }}>
            <div
                role="slider"
                aria-valuemin={actualMin}
                aria-valuemax={100}
                aria-valuenow={actualMax}
                onMouseDown={(e) => onMouseDown(e, { isTouch: false, handleID: DIAL_MAX_ID })}
                onTouchStart={(e) => onTouchStart(e, { isTouch: true, handleID: DIAL_MAX_ID })}
            />
        </div>,
    ];
};
